module.exports = __webpack_public_path__ + "img/img1.02cdf715.png";